import React from 'react'

import { globalWindow, isServerSide } from '@emico/ssr-utils'

// Right now this adds event listeners each time the hook is called. If that
// turns out to have a significant performance impact, we could store this
// value in a Context and share that instead. That way we can add these event
// just once.

// The innerWidth includes space reserved for scrollbars. Using innerWidth
// matches what @media breakpoints would use. See
// https://stackoverflow.com/a/18548239/684353 for more info.
export default function useWindowSize() {
  const [size, setSize] = React.useState<[number, number]>([
    globalWindow?.innerWidth ?? 1920,
    globalWindow?.innerHeight ?? 1080,
  ])
  function updateSize() {
    setSize([
      globalWindow?.innerWidth ?? 1920,
      globalWindow?.innerHeight ?? 1080,
    ])
  }

  if (isServerSide()) {
    return size
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useLayoutEffect(() => {
    updateSize()
    globalWindow?.addEventListener('resize', updateSize)
    globalWindow?.addEventListener('orientationchange', updateSize)
    return () => {
      globalWindow?.removeEventListener('resize', updateSize)
      globalWindow?.removeEventListener('orientationchange', updateSize)
    }
  }, [])
  return size
}
